import GeneratedLocationServiceApi from "./generated/GeneratedLocationServiceApi"

class LocationServiceApi extends GeneratedLocationServiceApi {

}

export const locationServiceApi = new LocationServiceApi()
